<template>
  <BittsLoading :is-loading="!isReady">
    <div class="api-webhooks-tab">
      <ApiTabEmptyState
        v-if="!webhookCards.length"
        title="No webhooks yet"
        description="Send Crossbeam signals to your own systems as they happen. Create a webhook to choose the events and the destination."
        create-cta-text="Create webhook"
        :icon="['fak', 'share']"
        @create="openCreate('webhooks')"
      />
      <template v-else>
        <ApiResourceCard
          v-for="webhook in webhookCards"
          :key="webhook.id"
          :name="webhook.name"
          :status="webhook.status"
          :status-text="webhook.statusText"
        >
          <template #actions>
            <ApiResourceCardActions
              action-text="Settings"
              :action-icon="['fak', 'settings']"
              :resource-name="webhook.name"
              @action="openDetail('webhooks', webhook.id)"
            />
          </template>
        </ApiResourceCard>
      </template>
    </div>
  </BittsLoading>
</template>

<script setup lang="ts">
import { BittsLoading } from '@crossbeam/bitts';

import { useHead } from '@unhead/vue';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import { useWebhooksStore } from '@/stores';
import { WEBHOOK_STATUS_CONFIG } from '@/types/webhooks';

import ApiResourceCard from '../components/ApiResourceCard.vue';
import ApiResourceCardActions from '../components/ApiResourceCardActions.vue';
import ApiTabEmptyState from '../components/ApiTabEmptyState.vue';
import useApiRoutes from '../useApiRoutes';

useHead({ title: 'Webhooks - API - Crossbeam' });

const { openCreate, openDetail } = useApiRoutes();
const webhooksStore = useWebhooksStore();
const { ready: isReady } = storeToRefs(webhooksStore);

const webhookCards = computed(() =>
  webhooksStore.webhooks.map((webhook) => ({
    id: webhook.id,
    name: webhook.name,
    status: WEBHOOK_STATUS_CONFIG[webhook.status].status,
    statusText: WEBHOOK_STATUS_CONFIG[webhook.status].text,
  })),
);
</script>
